<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">员工信息</span></div>
		<div class="topselectbox">

			<div class="topselect01">
				<div class="depselect" style="width: 230px;display:flex;">
					<span>部门：</span>
					<Select v-model="select" class="bmselect" @change="selectdep" :datas="param"></Select>
				</div>

				<!-- <div class="depselect depselect02" style="width: 250px;display:flex;">
					<span>员工状态：</span>
					<Select v-model="select" class="bmselect" :datas="param"></Select>
				</div> -->

				<div class="depselect" style="width: 250px;display:flex;">
					<span>姓名：</span>
					<a-input type="text" style="width:180px" v-model="selectobj.name" />
				</div>

				<div class="depselect"><button class="h-btn h-btn-blue" @click="selectmsg">查询</button> </div>

			</div>

			<div class="topselect02">

				<div><button class="h-btn h-btn-blue" @click="showDrawer(data = false)">增加员工</button>
					<button class="h-btn" @click="adddepartment">新增部门</button>
					<button class="h-btn" @click="exportToExcel">导出</button>
				</div>

			</div>


		</div>

		<div class="emtablebox">

			<Table :datas="datas" :height="400" :border="true" id="tb_person">
				<TableItem title="姓名" prop="name" :width="150" fixed="left" />
				<TableItem title="编号" align="center" prop="number" :width="100" />
				<TableItem title="部门" prop="departName" align="center" :width="150" />
				<TableItem title="职位" align="center" prop="postName" :width="150" />
				<TableItem title="手机号" prop="phone" align="center" :width="150" />
				<TableItem title="证件号" prop="idnum" align="center" :width="150" />
				<TableItem title="工资" prop="salaryAmount" align="center" :width="150" />
				<TableItem title="员工状态" align="center" :width="150">
					<template #default="{ data }">
						<span style="color:green;margin-right:10px;cursor: pointer;" v-if="data.state == '在职'">{{
							data.state
						}}</span>
						<span style="color:#999;margin-right:10px;cursor: pointer;" v-else>{{ data.state }}</span>
						<!-- <span style="color:blue;cursor: pointer;">删除</span> -->
					</template>
				</TableItem>

				<TableItem title="操作" :width="100" align="center" fixed="right">
					<template #default="{ data }">
						<span style="color:blue;margin-right:10px;cursor: pointer;" @click="showDrawer(data)">编辑</span>
						<span style="color:#888;cursor: pointer;" @click="deleteperson(data)">删除</span>
					</template>
				</TableItem>
				<template #empty>
					自定义提醒：暂时无数据
				</template>
			</Table>


		</div>




		<a-drawer title="编辑员工" width="1200" :closable="false" :visible="visible" @close="onClose">

			<div class="ziliaotable">
				<h3>基本信息</h3>
				<table>
					<tr>
						<td width="33%"> <span>*编号：</span> <a-input style="width:200px" v-model="edittable.code"
								placeholder="" /></td>
						<td width="33%"><span>*姓名：</span><a-input style="width:200px" v-model="edittable.name"
								placeholder="" /></td>
						<td width="33%"><span>*性别：</span>
							<a-select v-model="defaulsex" :default-value="defaulsex" style="width: 200px"
								@change="sexChange">
								<a-select-option v-for="(item, index) in sexlist" :key="item.valsex" :value="item.valsex">
									{{ item.value }}
								</a-select-option>
							</a-select>
						</td>
					</tr>
					<tr>
						<td width="33%">*证件类型：
							<a-select :default-value="defaultcardType" v-model="defaultcardType" style="width: 200px"
								@change="cardTypeChange">
								<a-select-option v-for="(item, index) in cardTypelist" :key="item.id" :value="item.name">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</td>
						<td width="33%">*证件号码：<a-input style="width:200px" v-model="edittable.cardNo" placeholder="" /></td>
						<td width="33%">*出生日期：
							<DatePicker v-model="edittable.birthday" style="width:200px" :format="'YYYY-MM-DD'"></DatePicker>
							 </td>
					</tr>
					<tr>
						<td width="33%">*手机：<a-input style="width:200px" v-model="edittable.phone" placeholder="" /></td>
						<td width="33%">*邮箱：<a-input style="width:200px" v-model="edittable.email" placeholder="" /></td>
						<td width="33%">*学历：
							<a-select :default-value="defauleducation" v-model="defauleducation" style="width: 200px"
								@change="educationChange">
								<a-select-option v-for="(item, index) in educationlist" :key="item.id" :value="item.name">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</td>
					</tr>
					<tr>
						<td width="33%">银行名称：<a-input style="width: 200px" v-model="edittable.bankName" placeholder="" />
						</td>
						<td width="33%">银行账号：<a-input style="width: 200px" v-model="edittable.bankCard" placeholder="" />
						</td>
						<td width="33%">*入职日期：<DatePicker  style="width:200px" v-model="edittable.joinTime" :format="'YYYY-MM-DD'"></DatePicker>
							<!-- <a-input style="width: 200px" v-model="edittable.joinTime" placeholder="2023-1-1" /> -->
						</td>
					</tr>
					<tr>
						<td width="33%">*部门：
							<a-select :default-value="defauldepartment" v-model="defauldepartment"
								@change="departmentChange" style="width: 200px">
								<a-select-option v-for="(item, index) in departmentlist" :key="item.id" :value="item.name">
									{{ item.name }}
								</a-select-option>

							</a-select>
						</td>
						<td width="33%">岗位：<a-input style="width: 200px" placeholder="" v-model="edittable.postName" /></td>
						<td width="33%">*工资始发日期： 
							<DatePicker v-model="edittable.wagesStartTime" style="width:200px" :format="'YYYY-MM-DD'"></DatePicker>
							 </td>
					</tr>
					<tr>
						<td width="33%">职称：<a-input style="width: 200px" v-model="edittable.title" placeholder="" /></td>
						<td width="33%">*计提工资科目：<a-input style="width: 200px" :disabled="true" placeholder="库存现金"
								value="库存现金" />
						</td>
						<td width="33%">备注：<a-input style="width: 200px" v-model="edittable.remark" placeholder="" /></td>
					</tr>
					<tr>
						<td width="33%">*员工状态：
							<a-select @change="stateChange" :default-value="edittable.state == 1 ? '在职' : '离职'"
								v-model="defaulstate" style="width: 200px">
								<a-select-option value="1">
									在职
								</a-select-option>
								<a-select-option value="2">
									离职
								</a-select-option>
							</a-select>
						</td>
						<td width="33%">工资：
							<a-input style="width:200px" v-model="edittable.salaryAmount"  /> 
						</td>
						<td width="33%">*是否合伙人：
							<h-switch v-model="edittable.isPartner" :small="true" style="width:200px;"></h-switch> 
						</td>
						<!-- <td width="33%">uuid：
							<a-input style="width:200px" v-model="edittable.uuid" placeholder="合伙人必填项" />
						</td>  -->
					</tr>
				</table>
			</div>

			<div class="fiveonebox">
				<h3>扣除款项</h3>
				<div class="selectfiveone">*是否缴纳五险一金：
					<a-radio-group name="radioGroup" :default-value="defaulfiveone" v-model="defaulfiveone"
						@change="onChangefiveone">
						<a-radio :value="true">
							是
						</a-radio>
						<a-radio :value="false">
							否
						</a-radio>

					</a-radio-group>
				</div>

				<div class="datagridbox" v-show="defaulfiveone">
					<table class="datagrid-htable" border="0" cellspacing="0" cellpadding="0" style="height: 74px;">
						<tbody>
							<tr class="datagrid-header-row">
								<td rowspan="2" field="E_CODE_NAME">
									<div class="datagrid-cell datagrid-cell-c2-E_CODE_NAME">
										<span>项 目</span>
										<span class="datagrid-sort-icon">&nbsp;</span>
									</div>
								</td>

								<td rowspan="2" field="BASE" class="">
									<div class="datagrid-cell datagrid-cell-c2-BASE">
										<span>缴纳基数</span>
										<span class="datagrid-sort-icon">&nbsp;</span>
									</div>
								</td>
								<td rowspan="1" colspan="2">
									<div class="datagrid-cell-group">公司承担部分</div>
								</td>
								<td rowspan="1" colspan="2">
									<div class="datagrid-cell-group">个人承担部分</div>
								</td>
							</tr>
							<tr class="datagrid-header-row">
								<td rowspan="1" colspan="1" field="COM_PERCENT">
									<div class="datagrid-cell datagrid-cell-c2-COM_PERCENT">
										<span>公司缴纳比例</span>
										<span class="datagrid-sort-icon">&nbsp;</span>
									</div>
								</td>
								<td rowspan="1" colspan="1" field="COM_AMOUNT">
									<div class="datagrid-cell datagrid-cell-c2-COM_AMOUNT">
										<span>公司缴纳金额</span>
										<span class="datagrid-sort-icon">&nbsp;</span>
									</div>
								</td>
								<td rowspan="1" colspan="1" field="PER_PERCENT" class="">
									<div class="datagrid-cell datagrid-cell-c2-PER_PERCENT">
										<span>个人缴纳比例</span>
										<span class="datagrid-sort-icon">&nbsp;</span>
									</div>
								</td>
								<td rowspan="1" colspan="1" field="PER_AMOUNT" class="">
									<div class="datagrid-cell datagrid-cell-c2-PER_AMOUNT"><span>个人缴纳金额</span><span
											class="datagrid-sort-icon">&nbsp;</span>
									</div>
								</td>
							</tr>
						</tbody>

						<tbody class="tbody02" v-if="edittable.insureState">
							<tr v-for="(item, index) in edittable.insures" :key="index">
								<td>
									{{ item.itemName }}
								</td>
								<td>
									<a-input placeholder="" v-model="item.paymentBase" style="width:80%" />
								</td>
								<td>
									<a-input placeholder="" v-model="item.companyRate" style="width: 80%" />
									<span>%</span>
								</td>
								<td>
									<a-input placeholder="" v-model="item.companyPayment" style="width: 90%" />
								</td>
								<td>
									<a-input placeholder="" v-model="item.personRate" style="width: 80%" />
									<span>%</span>
								</td>
								<td>
									<a-input placeholder="" v-model="item.personPayment" style="width: 90%" />
								</td>
							</tr>
						</tbody>

						<tbody class="tbody02" v-else>
							<tr v-for="(item, index) in edittable.insures" :key="index">
								<td>
									{{ item.itemName }}
								</td>
								<td>
									<a-input placeholder="" v-model="item.paymentBase" style="width:80%" />
								</td>
								<td>
									<a-input placeholder="" v-model="item.companyRate" style="width: 80%" />
									<span>%</span>
								</td>
								<td>
									<a-input placeholder="" v-model="item.companyPayment" style="width: 90%" />
								</td>
								<td>
									<a-input placeholder="" v-model="item.personRate" style="width: 80%" />
									<span>%</span>
								</td>
								<td>
									<a-input placeholder="" v-model="item.personPayment" style="width: 90%" />
								</td>
							</tr>
						</tbody>

					</table>
				</div>


			</div>


			<div :style="{
				position: 'absolute',
				bottom: 0,
				width: '100%',
				borderTop: '1px solid #e8e8e8',
				padding: '10px 16px',
				textAlign: 'right',
				left: 0,
				background: '#fff',
				borderRadius: '0 0 4px 4px',
			}">
				<a-button style="marginRight: 8px" @click="onClose">
					取消
				</a-button>
				<a-button type="primary" @click="onSave(clickstyle)">
					保存
				</a-button>
			</div>
		</a-drawer>



		<a-modal title="创建新部门" :visible="showcreat" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel"
			cancelText="取消" okText="确认">
			<ul class="newdecreat">
				<li>
					<span>部门编号：</span>
					<a-input style="width:280px" placeholder="请输入部门编号" v-model="newdepart.code" />
				</li>

				<li>
					<span>部门名称：</span>
					<a-input style="width:280px" placeholder="请输入部门名称" v-model="newdepart.name" />
				</li>
			</ul>
		</a-modal>




	</div>
</template>

<script>

import moment from 'moment'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'; 
import * as XLSX from 'xlsx';
export default {
	name: "Salarymanage",
	data() {
		return {
			dataList: {},
			select: 0,
			confirmLoading:false,
			param: [{ title: '全部', key: 0 }, { title: '选择1', key: 1 }, { title: '选择2', key: 2 }],
			selectobj: {
				name: '',
				accountSetsId: '',
				departId: '',
				key: '',
				title: ''
			},
			datas: [],
			size: 10,
			pagination: {
				page: 1,
				size: 10,
				total: 100
			},
			visible: false,
			edittable: {
				id: '',
				accountSetsId: '',
				code: '',
				name: '',
				sex: true,
				cardType: 1,
				cardNo: '',
				birthday: '',
				phone: '',
				email: '',
				bankName: '',
				bankCard: '',
				joinTime: '',
				postName: '',
				departId: '',
				education: 1,
				title: '',
				wagesStartTime: '',
				subjectId: 1,
				remark: '',
				state: 1,
				insureState: '',
				insures: []
			},
			//证件
			cardTypelist: [],
			defaultcardType: '身份证',
			sexlist: [{
				value: '男',
				valsex: 1
			}, {
				value: '女',
				valsex: 2
			}],
			//学历
			defauleducation: '初中',
			educationlist: [],
			//部门
			defauldepartment: '',
			departmentlist: [],
			defaulfiveone: false,
			defaulstate: '1',
			defaulsex: "男",
			clickstyle: 'new',
			//创建新部门
			showcreat: false,
			newdepart: {
				accountSetsId: '',
				code: '',
				name: ''
			}
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
	},
	methods: {

		//筛选
		selectdep(e) {

			console.log('e', e);

			var selectobj = {
				accountSetsId: e.accountSetsId,
				departId: e.departId,
				key: e.key,
				title: e.title,
				name: this.selectobj.name
			}

			this.selectobj = selectobj;

		},

		//员工信息
		getstafflist() {

			var selectobj = this.selectobj; 
			var accountSetsId = this.User.accountSetsId;
			var size = 50;
			var parmas = {
				accountSetsId,
				size,
				name: selectobj.name,
				departId: selectobj.departId
			}
			this.$api.wages.stafflist(parmas).then(data => {
				//this.datas = data.records;
				console.log('data', data);

				if (data.code == 200) {

					var staffarr = [];

					//console.log('data.code', data.code);

					data.data.records.forEach(e => {
						var record = {}
						record.id = e.id;
						record.name = e.name;
						record.number = e.code;
						record.departName = e.departName;
						record.position = e.title;
						record.phone = e.phone;
						record.postName=e.postName;
						record.idnum = e.cardNo;
						record.salaryAmount=e.salaryAmount;
						record.state = e.state == 1 ? '在职' : '离职';
						record.datass = e;
						staffarr.push(record);
					});

					this.datas = staffarr;
				}
			})

		},
		//部门列表
		getdepartment() {
			var accountSetsId = this.User.accountSetsId;
			var that = this;
			this.$api.wages.department(accountSetsId).then(departdata => {
				console.log('departdata', departdata);
				if (departdata.code == 200) {
					this.departmentlist = departdata.data;
					this.defauldepartment = departdata.data[0].name;
					this.edittable.departId = departdata.data[0].id;
					//param = [{ title: '全部', key: 0 }, { title: '选择1', key: 1 }, { title: '选择2', key: 2 }];
					var newarr = [{ title: '全部', key: 0 }];
					departdata.data.forEach(e => {
						var arrlist = {};
						arrlist.title = e.name;
						arrlist.key = e.code;
						arrlist.accountSetsId = e.accountSetsId;
						arrlist.departId = e.id;
						newarr.push(arrlist);
					});

					this.param = newarr;

				}
			})

		},


		async showDrawer(data) {
			var that = this;
			console.log('data', data);

			//获取证件类型
			await this.$api.wages.cardType().then(carddata => {
				//this.datas = data.records;
				var that = this;
				console.log('carddata', carddata);
				if (carddata.code == 200) {
					that.cardTypelist = carddata.data;

					if (data) {

						for (var i = 0; i < carddata.data.length; i++) {
							if (carddata.data[i].id == data.datass.cardType) {
								that.defaultcardType = carddata.data[i].name;
								break;
							}
							//console.log('i', i);
						};

					}



				}

			});

			//获取学历
			await this.geteducation(data);


			this.visible = true;

			if (data) {

				var edittabless = {
					id: data.datass.id,
					accountSetsId: data.datass.accountSetsId,
					code: data.datass.code,
					name: data.datass.name,
					sex: data.datass.sex,
					cardType: data.datass.cardType,
					cardNo: data.datass.cardNo,
					birthday: data.datass.birthday,
					phone: data.datass.phone,
					email: data.datass.email,
					bankName: data.datass.bankName,
					bankCard: data.datass.bankCard,
					joinTime: data.datass.joinTime,
					postName: data.datass.postName,
					departId: data.datass.departId,
					education: data.datass.education,
					wagesStartTime: data.datass.wagesStartTime,
					title: data.datass.title,
					subjectId: data.datass.subjectId,
					remark: data.datass.remark,
					state: data.datass.state,
					isPartner: data.datass.isPartner,
					salaryAmount:data.datass.salaryAmount,
					// uuid: data.datass.uuid,
					insureState: data.datass.insureState,
					insures: data.datass.insures
				}

				//五险一金
				this.defaulfiveone = data.datass.insureState;

				//性别
				this.defaulsex = data.datass.sex ? '男' : '女';

				//员工状态
				this.defaulstate = data.datass.state == 1 ? '在职' : '离职';

				//获取部门
				var departdata = this.departmentlist;

				for (var i = 0; i < departdata.length; i++) {
					if (departdata[i].id == data.datass.departId) {
						that.defauldepartment = departdata[i].name;
						break;
					}
				};

				this.clickstyle = 'old';


			} else {

				var accountSetsId = this.User.accountSetsId;

				var edittabless = {

					accountSetsId: accountSetsId,
					code: '',
					name: '',
					sex: this.edittable.sex,
					cardType: this.edittable.cardType,
					cardNo: '',
					birthday: '',
					phone: '',
					email: '',
					bankName: '',
					bankCard: '',
					joinTime: '',
					postName: '',
					departId: this.edittable.departId,
					education: this.edittable.education,
					title: '',
					wagesStartTime: '',
					subjectId: this.edittable.subjectId,
					remark: '',
					state: this.edittable.state,
					insureState: false,
					insures: []
				}

				this.defaulfiveone = false;
				this.clickstyle = 'new';


			}

			this.edittable = edittabless;

			//debugger;


			console.log('this.defaulfiveone', this.defaulfiveone);


		},
		//学历列表
		geteducation(data) {

			var that = this;

			this.$api.wages.education().then(edudata => {
				//this.datas = data.records;
				console.log('edudata', edudata);
				if (edudata.code == 200) {

					this.educationlist = edudata.data;

					if (data) {

						for (var i = 0; i < edudata.data.length; i++) {
							if (edudata.data[i].id == data.datass.education) {
								that.defauleducation = edudata.data[i].name;
								break;
							}
						};

					}



					//console.log('data11234', this.defauleducation);
				}

			});


		},

		//切换卡类型
		cardTypeChange(e, option) {
			console.log('e', e);
			console.log('option', option.data.key);
			this.edittable.cardType = option.data.key;

		},
		//切换性别
		sexChange(e, option) {
			console.log('e', e);
			console.log('option', option);
			this.edittable.sex = e == 1 ? 'true' : false;

			this.defaulsex = e == 1 ? '男' : '女';

		},

		//切换学历
		educationChange(e, option) {

			this.edittable.education = option.data.key;

		},
		//切换部门
		departmentChange(e, option) {

			this.edittable.departId = option.data.key;

		},
		//在职和离职
		stateChange(e) {
			this.edittable.state = e;
		},
		onClose() {
			this.visible = false;
		},
		onSave(clickstyle) {


			var edittable = this.edittable;
			console.log('edittable', edittable);

			//debugger;
			//编辑员工
			if (clickstyle == 'old') {
				// if(edittable.isPartner && edittable.uuid==undefined||edittable.uuid==''){
				// 	this.$message.error('合伙人uuid不能为空');
				// 	return;
				// }
				this.$api.wages.personedit(edittable).then(data => {
					
					console.log('data', data);
					if (data.code == 200) {

						this.visible = false;
						this.getstafflist();
						this.$message.success('编辑成功！');


					} else {
						this.$message.error('编辑失败');
					}

				});

			} else if (clickstyle == 'new') {

				this.$api.wages.personsave(edittable).then(data => {

					console.log('data', data);
					if (data.code == 200) {

						this.visible = false;
						this.getstafflist();
						this.$message.success('编辑成功！');


					} else {
						this.$message.error('编辑失败');
					}

				});



			}






		},

		//是否开启五险一金
		onChangefiveone(value) {

			this.defaulfiveone = value.target.value;
			this.edittable.insureState = value.target.value;

			//console.log('value', value);


			if (value.target.value && this.edittable.insures.length == 0) {
				this.loadList();
				console.log('执行了');
			}


		},
		//五险一金列表
		loadList() {

			var accountSetsId = this.User.accountSetsId;
			console.log('accountSetsId', accountSetsId);

			var parmas = {
				accountSetsId,
				personId: '-1'
			}

			var that = this;

			this.$api.wages.insureList(parmas).then(data => {
				//this.datas = data.records;
				if (data.code == 200) {
					that.edittable.insures = data.data;
				}

				console.log('that.edittable.insures', that.edittable.insures);


			})
		},


		showChildrenDrawer() {
			this.childrenDrawer = true;
		},
		onChildrenDrawerClose() {
			this.childrenDrawer = false;
		},

		selectmsg(e) {
			var selectobj = this.selectobj;
			//console.log('222', selectobj);
			this.getstafflist()

		},
		//删除员工
		deleteperson(data) {
			console.log('data', data);
			var id = data.id;
			var that = this;

			this.$confirm({
				title: '确认信息?',
				content: '是否确定删除？',
				okText: '确认删除',
				cancelText: '取消',
				onOk() {

					that.$api.wages.deleteperson(id).then(data => {

						console.log('data', data);
						if (data.code == 200) {
							that.getstafflist();
							that.$message.success('删除成功！');
						} else {
							that.$message.error('删除失败');
						}

					});

				},
				onCancel() {

				}
			});

		},
		//新增部门
		adddepartment() {

			this.showcreat = true;

		},
		//提交
		handleOk(e) {
			var accountSetsId = this.User.accountSetsId;
			var that = this;

			if (!this.newdepart.code) {
				this.$message.warning('请输入部门编码！');
				return;
			}

			if (!this.newdepart.name) {
				this.$message.warning('请输入部门名称！');
				return;
			}

			var parmas = {
				accountSetsId: accountSetsId,
				code: this.newdepart.code,
				name: this.newdepart.name
			};

			that.$api.wages.adddepartment(parmas).then(data => {

				//console.log('data', data);
				if (data.code == 200) {
					this.showcreat = false;
					that.getstafflist();
					this.getdepartment();
					that.$message.success('部门添加成功！');
				} else {
					that.$message.error('部门添加失败');
				}

			});


		},
		//取消
		handleCancel(e) {
			//console.log('Clicked cancel button');
			this.showcreat = false;
		},
		//导出数据
		exportToExcel(){ 
			var selectobj = this.selectobj; 
			var accountSetsId = this.User.accountSetsId; 
			var parmas = {
				accountSetsId, 
				name: selectobj.name,
				departId: selectobj.departId
			}	
			this.$api.exportExcel.person(parmas).then(data => {
				let objectUrl = window.URL.createObjectURL(new Blob([data]))
				console.log(objectUrl);
				const link = document.createElement('a')
				link.download = '员工.xls'
				link.href = objectUrl
				link.click()
		
			}) 
		},



	},
	mounted() {
		this.getstafflist();
		this.getdepartment();
	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}


}

.topselectbox {
	padding-top: 10px;
	padding-left: 10px;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.topselectbox .depselect {
	float: left;
	padding-left: 10px;
	padding-top: 10px;
	display: flex;
	justify-content: left;
	align-items: center;
	font-weight: normal;
}

.topselectbox .depselect span {}

.topselectbox .depselect .bmselect {
	width: 160px;
}

.topselectbox .depselect02 {
	padding-top: 10px;
	float: left;
	display: flex;
	justify-content: left;
	align-items: center;
}

.topselectbox .depselect02 span {}

.topselectbox .depselect02 .bmselect {
	width: 160px;
}

.emtablebox {
	padding-top: 20px;
	padding-left: 18px;
	min-height: 650px;
}

.emtablebox tbody {}

.emtablebox table tbody tr td {
	font-weight: normal !important;
	;
}

.yemabox {
	padding-top: 50px;
	padding-bottom: 30px;
}


.ziliaotable {}

.ziliaotable table {
	width: 100%
}

.ziliaotable table tr {
	width: 100%;
	display: flex;
	justify-content: left;
	align-items: center;
}

.ziliaotable table tr td {
	display: flex;
	padding-top: 10px;
	padding-bottom: 10px;
	justify-content: right;
	align-items: center;
	width: 100%;
}

.fiveonebox {
	padding-top: 20px;
	padding-bottom: 100px;
}

.fiveonebox h3 {
	padding-top: 20px;
	padding-bottom: 10px;
}

.datagridbox {
	padding-top: 20px;
}

.datagrid-htable {
	width: 100%;
}

.datagrid-htable tr td {
	border: 1px solid #ddd;
	text-align: center;
	padding-top: 10px;
	padding-bottom: 10px;
	vertical-align: middle;
}

.datagrid-htable tr.datagrid-header-row td {
	border: 1px solid #ddd;
	text-align: center;
	background: #f2f2f2;
}

.datagrid-htable tr td div {
	text-align: center;
}

.datagrid-htable .tbody02 {}

.datagrid-htable .tbody02 tr td {
	vertical-align: middle !important;
}

.datagrid-htable .tbody02 tr td span {
	padding-left: 5px;
	padding-top: 10px;
}

.newdecreat {}

.newdecreat li {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
}
</style>
